import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.5 4C13.5 3.6585 13.5311 3.32428 13.5907 3H4V22.9432L12 17.2289L20 22.9432V9.40931C19.6757 9.46888 19.3415 9.5 19 9.5C15.9624 9.5 13.5 7.03757 13.5 4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H15V5H23V3Z"}}]};

const BookmarkMinusFilled = Vue.extend<IconProps>({
  name: 'BookmarkMinusFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bookmark-minus-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BookmarkMinusFilled;
